export const dateFormatter = new Intl.DateTimeFormat("nb-NO", {
  weekday: "short",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit"
});

export const timeFormatter = new Intl.DateTimeFormat("nb-NO", {
  hour: "2-digit",
  minute: "2-digit"
});

export const planDateFormatter = new Intl.DateTimeFormat("nb-NO", {
  day: "numeric",
  month: "short",
  year: "numeric"
});

export const monthLabelFormatter = new Intl.DateTimeFormat("nb-NO", {
  month: "long",
  year: "numeric"
});

export function formatPlanTime(startsAt: string, endsAt?: string): string {
  const start = new Date(startsAt);
  if (!endsAt) return dateFormatter.format(start);
  const end = new Date(endsAt);
  return `${dateFormatter.format(start)}-${timeFormatter.format(end)}`;
}

// Date-only label for completed plans, e.g. "12. juni 2026".
export function formatPlanDate(value: string): string {
  return planDateFormatter.format(new Date(value));
}

// Month bucket key (e.g. "2026-05") and human label (e.g. "mai 2026") used to
// group the past-plans history.
export function monthBucketKey(value: string): string {
  const date = new Date(value);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function formatMonthLabel(value: string): string {
  return monthLabelFormatter.format(new Date(value));
}

const relativeDayMonthFormatter = new Intl.DateTimeFormat("nb-NO", {
  day: "numeric",
  month: "short"
});

const relativeDayMonthYearFormatter = new Intl.DateTimeFormat("nb-NO", {
  day: "numeric",
  month: "short",
  year: "numeric"
});

function startOfDay(value: Date): number {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
}

// Relative time label for timestamps, e.g. "nå", "12 min siden", "2 t siden",
// "i går", "4 dager siden", falling back to a short date once it's a week old.
export function formatRelativeTime(value: string, now: Date = new Date()): string {
  const date = new Date(value);
  const diffSeconds = Math.max(0, Math.floor((now.getTime() - date.getTime()) / 1000));

  if (diffSeconds < 45) return "nå";

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) return `${diffMinutes} min siden`;

  const diffHours = Math.floor(diffMinutes / 60);
  const dayDiff = Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);

  if (dayDiff <= 0) return `${diffHours} t siden`;
  if (dayDiff === 1) return "i går";
  if (dayDiff < 7) return `${dayDiff} dager siden`;

  return date.getFullYear() === now.getFullYear()
    ? relativeDayMonthFormatter.format(date)
    : relativeDayMonthYearFormatter.format(date);
}

export function initials(name: string | null | undefined): string {
  const cleaned = (name || "Join").trim();
  return cleaned
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

export function relationshipLabel(state: string): string {
  switch (state) {
    case "friends":
      return "Venner";
    case "incoming_request":
      return "Forespørsel mottatt";
    case "outgoing_request":
    case "pending":
      return "Sendt";
    case "self":
      return "Deg";
    default:
      return "Legg til";
  }
}
